





















import { Vue, Component } from 'vue-property-decorator';
import Comments from '@/components/business/comments/Comments.vue';
import americanFlag from '@/assets/user/american-flag-2x.png';
import canadaFlag from '@/assets/user/canada-flag-2x.png';
import ukFlag from '@/assets/user/uk-flag-2x.png';
import CommentSwiper from '@/components/business/comments/CommentSwiper.vue';
import WebFooter from '@/components/business/WebFooter.vue';

@Component({
  components: {
    Comments,
    CommentSwiper,
    WebFooter,
  },
})
export default class UserVoice extends Vue {
  public get commentsData() {
    return [
      {
        avatar: americanFlag,
        userName: this.$t('匿名用户'),
        comment: this.$t('录入学校号码确认后免除了很多信息填写，特别省事体验还是比去银行汇款方便得多。'),
        userSchool: this.$t('University of Southern California'),
      },
      {
        avatar: americanFlag,
        userName: this.$t('匿名用户'),
        comment: this.$t('同学推荐使用的，汇款非常快，隔日就到海外学校了。'),
        userSchool: this.$t('New York University'),
      },
      {
        avatar: americanFlag,
        userName: this.$t('匿名用户'),
        comment: this.$t('大厂的产品值得信赖，整体体验还是不错的。'),
        userSchool: this.$t('University Of Washington'),
      },
      {
        avatar: americanFlag,
        userName: this.$t('匿名用户'),
        comment: this.$t('操作挺简单的，填写流程以及需要准备的资料都标注得挺清楚的，很方便。'),
        userSchool: this.$t('Johns Hopkins University'),
      },
      {
        avatar: canadaFlag,
        userName: this.$t('匿名用户'),
        comment: this.$t('服务挺好的，以后学费都可以通过这个交了。很快，比银行方便多了。'),
        userSchool: this.$t('York University'),
      },
      {
        avatar: ukFlag,
        userName: this.$t('匿名用户'),
        comment: this.$t('要认真夸夸这个产品！到账很快，整体下来还十分划算，客服小姐姐也很热情有耐心~'),
        userSchool: this.$t('Cardiff University'),
      },
    ];
  }
}
